import { render, staticRenderFns } from "./IconBlock.vue?vue&type=template&id=4c9c8468&"
import script from "./IconBlock.vue?vue&type=script&lang=js&"
export * from "./IconBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports